import { render } from "./App.vue?vue&type=template&id=04d3ea4c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=04d3ea4c&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/play-spider-web-prod-s3-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__